export default __webpack_public_path__ + "static/media/avatar.c3f94521.png";